
class User {
    type: string;
    
    constructor(options: any = { }) {
      return this;
    }
    
  }
  
  export { User };
  